import { Component, OnInit } from '@angular/core';
import {
  AlertController,
  MenuController,
  ActionSheetController,
  ModalController,
} from '@ionic/angular';
import { VerificationComponent } from '../shared/verification/verification.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  sheetState: any;

  constructor(
    private menu: MenuController,
    public alertController: AlertController,
    public modalController: ModalController,
  ) {}

  ngOnInit() {
    // this.presentAlert()
  }

  openEnd() {
    this.menu.open('end');
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Alert',
      subHeader: 'Subtitle',
      message: 'This is an alert message.',
      buttons: ['OK'],
    });
    await alert.present();
    const { role } = await alert.onDidDismiss();
  }

  async presentModal() {
    const modal = await this.modalController.create({
      component: VerificationComponent,
      cssClass: 'my-custom-class',
      componentProps: {
        firstName: 'Douglas',
        lastName: 'Adams',
        middleInitial: 'N',
      },
    });
    return await modal.present();
  }

  async openBottomSheet() {
    const modal = await this.modalController.create({
      component: VerificationComponent,
      showBackdrop: true,
      mode: "ios",
      cssClass: 'change-address-shipping-modal'
    });
    return await modal.present();
  }
}
